// frontend/src/hooks/useResponsive.js
import { useState, useEffect } from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const useResponsive = () => {
    const { token } = useToken();
    const [isMobile, setIsMobile] = useState(window.innerWidth < token.screenMD);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < token.screenMD);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [token.screenMD]);

    return { isMobile };
};

export default useResponsive;